/**
 *
 * Dashboard
 *
 */
import {useCallback, useEffect, useState} from "react";
import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {createStructuredSelector} from "reselect";
import {compose} from "redux";
import styled from "styled-components";
import {
  makeSelectEndProductTypes,
  makeSelectInsurersApp,
  makeSelectMessagesStatusOpenCount,
  makeSelectPracticeMessages,
} from "containers/App/selectors";
import {
  getDentistActionApp,
  getEndProductTypesAction,
  getInsurersActionApp,
  getPracticeMessages,
} from "containers/App/actions";
import ForegroundBlob, {BlobContent,} from "basicComponents/ForegroundBlob/ForegroundBlob";
import {makeSelectPractice} from "../PracticePage/selectors";
import {DATE_FORMATS} from "utils/Date";
import {FormattedMessage} from "react-intl";
import messages from "./messages";
import GlobalMessages from "messages/messages";
import MessageOverview from "../../components/MessageOverview/MessageOverview";
import {useDebounce} from "use-debounce";
import {withRouter} from "react-router";
import {CalendarView} from "components/CalendarView";
import Header from "basicComponents/Header/Header";
import SubHeader from "basicComponents/SubHeader/SubHeader";
import bookMessages from "components/BookDay/messages";
import OrderPatientSearch from "containers/OrderPatientSearch/OrderPatientSearch";
import PatientOverview from "components/PatientOverview/PatientOverview";
import { getBearer } from "utils/userStorage";
import RefrezhButton from "components/RefrezhButton";
import PlusIcon from "images/PlusIcon";
import { clamp } from "lodash";

export function Dashboard({
  onGetInsurers,
  onGetDentists,
  onGetEndProductTypes,
  onGetPracticeMessages,
  practice,
  practiceMessages,
  statusOpenCount,
  history,
}) {
  const [filter, setFilter] = useState("");
  const [status, setStatus] = useState(1);
  const [items, setItems] = useState([]);

  const [inputText] = useDebounce(filter, 300);
  const { allowedToOrder = false, allowedToPlan = false } = practice;

  let [total,settotal] = useState(10)
  let pagesize = 10
  var [page,setpage] = useState(0)
  let pagecount = Math.ceil(total / pagesize)
  useEffect(() => {
    //hier
    fetch(`${__URLS__["api"]}practices/${practice.id}/patients/pagination/filter2?limit=${pagesize}&offset=${page * pagesize}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getBearer()}`,
      },
      body:JSON.stringify({
        filter:filter
      })
    }).then(res => res.json())
    .then((data) => {
      console.log(data.result)
      setItems(data.result)
      settotal(data.total)
    })
  },[page,filter])

  useEffect(
    () => {
      onGetEndProductTypes();
      onGetInsurers();
      onGetDentists();
    },
    [onGetDentists, onGetEndProductTypes, onGetInsurers],
  );

  // filter status!
  useEffect(
    () => {
      onGetPracticeMessages({
        limit: 2,
        offset: 0,
        filter: inputText,
        status,
      });
    },
    [inputText, onGetPracticeMessages, status],
  );

  const handleDayClicked = useCallback(
    day => {
      localStorage.setItem("calendarreferrer",location.pathname)
      history.push(`timeslots/${day.format(DATE_FORMATS.SIMPLE)}`, {
        searchedDate: day.format(DATE_FORMATS.SIMPLE),
      });
    },
    [history],
  );

  const handlePatientOrderClicked = useCallback(
    patient => {
      history.push(`/order/patient/${patient.id}/treatment`);
    },
    [history],
  );

  const handlePatientSearchClicked = useCallback(
    patient => {
      history.push(`/patient/${patient.id}`);
    },
    [history],
  );

  // const renderUpperBlob = useCallback(
  //   () => (
  //     <ForegroundBlob>
  //       <BlobContent>
  //         <div style={{width:"100%"}}>
  //           <div>
  //             <Header disableMargin>
  //               <FormattedMessage {...GlobalMessages.patient_overview} />
  //             </Header>
  //             <SubHeader extraMargin center>
  //               <FormattedMessage {...GlobalMessages.search_message} />
  //             </SubHeader>
  //             <PatientOverview
  //               // showArrow={false}
  //               showTableContent
  //               items = {items}
  //               practice={practice}
  //               onFilter={filter => {
  //                 // this.setState({ filter });
  //                 // this.paginationRef.current.update();
  //               }}
  //               onEditPatient={(patient, icon) => {
  //                 if (icon === "ADD") {
  //                   History.push(`treatment/new/${patient.id}`);
  //                   return;
  //                 }
              
  //                 if (icon === "EDIT") {
  //                   History.push(`treatment/edit/${patient.id}`);
  //                 }
  //               }}
  //             ></PatientOverview>
  //           </div>

  //           <div style={{display:'flex',justifyContent:'space-between'}}>
  //             <ContentWidget>
  //               <Header disableMargin>
  //                 <FormattedMessage {...bookMessages.agenda} />
  //               </Header>
  //               <SubHeader extraMargin center>
  //                 <FormattedMessage {...bookMessages.subHeader} />
  //               </SubHeader>
  //               <CalendarView onClick={handleDayClicked} />
  //             </ContentWidget>

  //             <ContentWidget>
  //               <MessageOverview
  //                 messages={practiceMessages}
  //                 filter={filter}
  //                 onFilterChange={setFilter}
  //                 practice={practice}
  //                 status={status}
  //                 statusOpenCount={statusOpenCount}
  //               />
  //             </ContentWidget>
  //           </div>
  //         </div>
  //       </BlobContent>
  //     </ForegroundBlob>
  //   ),
  //   [handleDayClicked, handlePatientSearchClicked, history],
  // );

  // const renderLowerBlob = useCallback(
  //   () => (
  //     <ForegroundBlob>
  //       <BlobContent>
  //         <ContentWidget marginRight medium>
  //           <Header disableMargin>
  //             <FormattedMessage {...messages.orderProductHeader} />
  //           </Header>
  //           <SubHeader extraMargin center>
  //             <FormattedMessage {...messages.selectPatientOrder} />
  //           </SubHeader>
  //           <OrderPatientSearch
  //             onPatientClick={handlePatientOrderClicked}
  //             onClickExpand={f => {
  //               history.push("/patients", { search: f });
  //             }}
  //             onNewClick={f => {
  //               let routeState;

  //               if (parseInt(f.replace(/-|_|#|\/|\s/g, ""), 10)) {
  //                 routeState = {
  //                   internalRef: f,
  //                 };
  //               } else {
  //                 routeState = {
  //                   name: f,
  //                 };
  //               }

  //               history.push("/patients/new", routeState);
  //             }}
  //           />
  //         </ContentWidget>
  //         <ContentWidget>
  //           <MessageOverview
  //             messages={practiceMessages}
  //             filter={filter}
  //             onFilterChange={setFilter}
  //             practice={practice}
  //             status={status}
  //             statusOpenCount={statusOpenCount}
  //           />
  //         </ContentWidget>
  //       </BlobContent>
  //     </ForegroundBlob>
  //   ),
  //   [
  //     filter,
  //     handlePatientOrderClicked,
  //     history,
  //     practice,
  //     practiceMessages,
  //     status,
  //     statusOpenCount,
  //   ],
  // );


  return (
    <Wrapper data-cy="dashboardItems">
      <ForegroundBlob>
        <BlobContent>
          <div style={{width:"100%"}}>
            <div>
              <Header disableMargin>
                <FormattedMessage {...GlobalMessages.patient_overview} />
              </Header>
              <SubHeader extraMargin center>
                <FormattedMessage {...GlobalMessages.search_message} />
              </SubHeader>
              <PatientOverview
                showArrow={false}
                showTableContent
                items = {items}
                practice={practice}
                maxHeight
                resetPatients = {() => {
                  setFilter("")
                  // fetch(`${__URLS__["api"]}practices/${practice.id}/patients/pagination/filter`, {
                  //   method: 'POST',
                  //   headers: {
                  //     "Content-Type": "application/json",
                  //     "Authorization": `Bearer ${getBearer()}`,
                  //   },
                  //   body:JSON.stringify({filter:""})
                  //   }).then(res => res.json())
                  //   .then((data) => {
                  //     setItems(data.list)
                  //     console.log(data)
                  //   })
                }}
                onFilter={filter => {
                  setTimeout(() => {
                    setpage(0)//hier gaat iets fout
                  }, 1000);
                  setFilter(filter.filter)
                  // fetch(`${__URLS__["api"]}practices/${practice.id}/patients/pagination/filter`, {
                  //   method: 'POST',
                  //   headers: {
                  //     "Content-Type": "application/json",
                  //     "Authorization": `Bearer ${getBearer()}`,
                  //   },
                  //   body:JSON.stringify(filter)
                  //   }).then(res => res.json())
                  //   .then((data) => {
                  //     setItems(data.list)
                  //     // console.log(data)
                  //   })
                }}
                onEditPatient={(patient, icon) => {
                  if (icon === "ADD") {
                    History.push(`treatment/new/${patient.id}`);
                    return;
                  }
              
                  if (icon === "EDIT") {
                    History.push(`treatment/edit/${patient.id}`);
                  }
                }}
              ></PatientOverview>
              <div style={{display:'flex',justifyContent:'center',gap:'10px', marginTop:'5px'}}>
                <RefrezhButton style={{background:'white'}} onClick={() => {
                  let clamped = clamp(page - 1, 0, pagecount - 1)
                  setpage(clamped)
                }}>vorige</RefrezhButton>
                <div>{page + 1}/{pagecount}</div>
                <RefrezhButton style={{background:'white'}} onClick={() => {
                  let clamped = clamp(page + 1,0, pagecount - 1)
                  setpage(clamped)
                }}>volgende</RefrezhButton>
              </div>
              <br></br>
            </div>

            <div style={{display:'flex',justifyContent:'space-between',flexWrap:"wrap", gap:'10px'}}>
              <ContentWidget>
                <Header disableMargin>
                  <FormattedMessage {...bookMessages.agenda} />
                </Header>
                <SubHeader extraMargin center>
                  <FormattedMessage {...bookMessages.subHeader} />
                </SubHeader>
                <CalendarView onClick={handleDayClicked} />
                <div style={{display:'flex',justifyContent:'center',marginTop:'10px'}}>
                  {(() => {
                    if(practice.allowedToPlan){
                      return <RefrezhButton onClick={() => {
                        history.push(`/timespan/plan`)
                      }}>Dagdeel boeken <PlusIcon></PlusIcon></RefrezhButton>
                    }
                  })()}
                </div>
              </ContentWidget>

              <ContentWidget>
                <MessageOverview
                  messages={practiceMessages}
                  filter={filter}
                  onFilterChange={setFilter}
                  practice={practice}
                  status={status}
                  statusOpenCount={statusOpenCount}
                />
              </ContentWidget>
            </div>
          </div>
        </BlobContent>
      </ForegroundBlob>
    </Wrapper>
  );
}

Dashboard.propTypes = {
  onGetEndProductTypes: PropTypes.func.isRequired,
  practice: PropTypes.any,
  onGetInsurers: PropTypes.func,
  onGetDentists: PropTypes.func,
  practiceMessages: PropTypes.array,
  onGetPracticeMessages: PropTypes.func,
  statusOpenCount: PropTypes.number,
  history: PropTypes.object,
};

/**
 * @return {number}
 */
function MaxWidth({ large, medium }) {
  if (large) {
    return 50;
  }

  if (medium) {
    return 40;
  }

  return 26;
}

const ContentWidget = styled.div`
  background:white;
  padding:20px;
  border-radius:20px;
  border:1px solid grey;
  width: 100%;
  max-width: 100%;
  ${({ marginRight, theme }) =>
    marginRight && `margin-right: ${theme.margin * 2}rem;`};

  
`;

// ${({ theme }) => theme.desktopUp`
//     max-width: ${MaxWidth}rem;
//   `};

const Wrapper = styled.div`
  width: 100%;
  display: block;
`;

const mapStateToProps = createStructuredSelector({
  practice: makeSelectPractice(),
  insurers: makeSelectInsurersApp(),
  endProductTypes: makeSelectEndProductTypes(),
  practiceMessages: makeSelectPracticeMessages(),
  statusOpenCount: makeSelectMessagesStatusOpenCount(),
});

function mapDispatchToProps(dispatch) {
  return {
    onGetEndProductTypes: () => dispatch(getEndProductTypesAction()),
    onGetDentists: () => dispatch(getDentistActionApp()),
    onGetInsurers: () => dispatch(getInsurersActionApp()),
    onGetPracticeMessages: config => dispatch(getPracticeMessages(config)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  withRouter,
)(Dashboard);
